import { render, staticRenderFns } from "./WechatService.vue?vue&type=template&id=99024074&scoped=true"
import script from "./WechatService.vue?vue&type=script&lang=js"
export * from "./WechatService.vue?vue&type=script&lang=js"
import style0 from "./WechatService.vue?vue&type=style&index=0&id=99024074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99024074",
  null
  
)

export default component.exports